import routerOptions0 from "/builds/nht4944308/products/malarkey/malarkey-nuxt-web-app/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}